export function getRandomInt(min = 10000000, max = 50000000) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1) + min);
}

export function getRandomFloat(min: number, max: number): number {
	return Math.random() * (max - min) + min;
}

export function isNumber(v: string | number | undefined) {
	const n = Number(v);
	return v !== '' && typeof n === 'number' && !isNaN(n) && isFinite(n);
}
